import { render, staticRenderFns } from "./ListarUnidade.vue?vue&type=template&id=53ab7080"
import script from "./ListarUnidade.vue?vue&type=script&lang=js"
export * from "./ListarUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports